import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { normalizeLang, type Lang } from "@/i18n/languages";

export function useLocalization() {
  const { lang } = useParams();
  const currentLang = normalizeLang(lang);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (i18n.language !== currentLang) {
      i18n.changeLanguage(currentLang);
    }
    document.documentElement.lang = currentLang;
  }, [currentLang, i18n]);

  return { lang: currentLang as Lang, t };
}